import { List, fromJS } from 'immutable';

export const addPriceToBaseProduct = product => {
  if (!product.get('variants', List).size) {
    return product;
  }

  const cheapestVariant = product
    .get('variants')
    .sortBy(variant => variant.get('price'))
    .take(1)
    .get(0);
  const productPrice = cheapestVariant.get('price');
  const productOriginalPrice =
    productPrice < cheapestVariant.get('originalPrice') ? cheapestVariant.get('originalPrice') : null;

  return product.merge({ price: productPrice, originalPrice: productOriginalPrice });
};

export const mapToObject = data => {
  // If result is an array
  if (Array.isArray(data)) {
    const newList = data.reduce(
      (memo, item) => Object.assign({ [item.id]: addPriceToBaseProduct(fromJS(item)) }, memo),
      {}
    );
    return fromJS(newList);
  }

  // If result is a single product
  if (Array.isArray(data.variants)) {
    return { [data.id]: data };
  }

  // If result is a editorial page
  if (data.url) {
    return { [data.url]: data };
  }

  // If result is a category
  return { [data.systemId]: data };
};



// WEBPACK FOOTER //
// ./src/util/mapToObject.js